import React from 'react';
import {
  Datagrid,
  DisabledInput,
  Edit,
  EditButton,
  Filter,
  ImageField,
  ImageInput,
  List,
  NumberInput,
  SelectInput,
  SimpleForm,
  TextField,
  TextInput,
} from 'admin-on-rest';
import { numberMinValidation } from './utils/validation';
import { ImageFieldOrNull, format, fixIfEmptyArray } from './common'
import { CountriesAutoComplete } from "./components/autoComplete";
import RitualsSelect from './components/ritualsSelect';

const PriceFilter = (props) => {
  return (
    <Filter {...props}>
      <CountriesAutoComplete source='country' label='Country' {...props} />
      <SelectInput
        label="Platform"
        source="platform"
        choices={[{ id: 'ios', name: 'iOs' }, { id: 'android', name: 'Android' }]}
      />
      <SelectInput
        label="Price presence"
        source="price"
        choices={[{ id: true, name: 'With price' }, { id: false, name: 'Without a price' }]}
      />
      <SelectInput
        label="Shop presence"
        source="inShop"
        choices={[{ id: true, name: 'In Shop' }, { id: false, name: 'Not in shop' }]}
      />
      <TextInput label="Private questions" source="privateQuestions" type="number" />
      <TextInput label="Public questions" source="publicQuestions" type="number" />
      <RitualsSelect label="Session" source="sessionType" {...props} />
      <TextInput label="Product Identifier" source="productIdentifier" />
    </Filter>
  )
}

export const PriceList = (props) => (
  <List {...props} filters={<PriceFilter />} perPage={40} sort={{ field: '_id', order: 'DESC' }}>
    <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
      <TextField label="Product Identifier" source="productIdentifier" />
      <TextField label="Country" source="country" />
      <TextField label="Platform" source="platform" />
      <TextField label="Price" source="price" />
      <TextField label="Discount" source="discount" />
      <TextField label="Currency" sortable={false} source="countryObject.currency" />
      <EditButton />
    </Datagrid>
  </List>
)

export const PriceEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <DisabledInput source="id" />
      <DisabledInput source="productIdentifier" label="Product Identifier" />
      <ImageField source="productIcon" />
      <ImageInput source="productIcon" accept="image/*" format={format} validate={fixIfEmptyArray}>
        <ImageFieldOrNull source="src" />
      </ImageInput>
      <DisabledInput label="Country" source="country" />
      <DisabledInput label="Platform" source="platform" />
      <TextField label="Currency" source="countryObject.currency" />
      <NumberInput validate={numberMinValidation} label="Price" source="price" />
      <DisabledInput
        label="Price per item(updated only after page reload)"
        source="pricePerItem"
        defaultValue="Could not count or zero"
      />
      <NumberInput validate={numberMinValidation} label="Discount" source="discount" />
    </SimpleForm>
  </Edit>
)



// WEBPACK FOOTER //
// ./src/packages.js